import React from 'react';

const SummaryList = ({responseSummary}) => {
    return (
        <div>
            {responseSummary.Rate && <div className="row mb-2">
                <div className="col-7">{responseSummary.Rate.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.Rate.units}{responseSummary.Rate.value}</b></div>
            </div>}
            {responseSummary.ComparisonRate && <div className="row mb-2">
                <div className="col-7">{responseSummary.ComparisonRate.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.ComparisonRate.value}{responseSummary.ComparisonRate.units}</b></div>
            </div>}
            {responseSummary.AnnualRate && <div className="row mb-2">
                <div className="col-7">{responseSummary.AnnualRate.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.AnnualRate.value}{responseSummary.AnnualRate.units}</b></div>
            </div>}
            {responseSummary.DownPayment && <div className="row mb-2">
                <div className="col-7">{responseSummary.DownPayment.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.DownPayment.units}{responseSummary.DownPayment.value}</b></div>
            </div>}
            {responseSummary.Term && <div className="row mb-2">
                <div className="col-7">{responseSummary.Term.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.Term.value}</b></div>
            </div>}
            {responseSummary.KMLimit && <div className="row mb-2">
                <div className="col-7">{responseSummary.KMLimit.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.KMLimit.value}{responseSummary.KMLimit.units}</b></div>
            </div>}
            {responseSummary.GuaranteedFutureValue && <div className="row mb-2">
                <div className="col-7">{responseSummary.GuaranteedFutureValue.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.GuaranteedFutureValue.units}{responseSummary.GuaranteedFutureValue.value}</b></div>
            </div>}
            {responseSummary.Balloon && <div className="row mb-2">
                <div className="col-7">{responseSummary.Balloon.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.Balloon.value}{responseSummary.Balloon.units}</b></div>
            </div>}
            {responseSummary.BalloonAmount && <div className="row mb-2">
                <div className="col-7">{responseSummary.BalloonAmount.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.BalloonAmount.units}{responseSummary.BalloonAmount.value}</b></div>
            </div>}
            {responseSummary.NAF && <div className="row mb-2">
                <div className="col-7">{responseSummary.NAF.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.NAF.units}{responseSummary.NAF.value}</b></div>
            </div>}
            {responseSummary.TotalAmountPayable && <div className="row mb-2">
                <div className="col-7">{responseSummary.TotalAmountPayable.label}</div>
                <div className="col-5 text-right"><b>{responseSummary.TotalAmountPayable.units}{responseSummary.TotalAmountPayable.value}</b></div>
            </div>}
        </div>
    );
}

export default SummaryList;
